import { BTMenu } from "@btnet/core-components/BTMenu";

import { BTIconTextBolder } from "commonComponents/btWrappers/BTIcon";
import { isSelectionExclusivelyInTitle } from "commonComponents/btWrappers/editor/core/editor.utils";
import { type ICollapsableControl } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/CollapsableControlGroup/CollapsableControlGroup";
import { EditorControlButton } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/EditorControlButton/EditorControlButton";
import { InputRecaptureHackMenuItem } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/InputRecaptureHack/InputRecaptureHack";
import { type ExtensionName } from "commonComponents/btWrappers/editor/core/extensions/editorExtensionUtils";
import { type IEditor } from "commonComponents/btWrappers/editor/core/useBTEditor.types";

const extensionId = "bold";
const friendlyName = "Bold";
const icon = <BTIconTextBolder />;
const onClick = (editor: IEditor) => {
    return editor.tiptapEditor.chain().focus().toggleBold().run();
};

export const boldControl: ICollapsableControl = {
    key: extensionId,
    isControlSupported(supportedExtensions: Set<ExtensionName>, editor: IEditor) {
        return (
            supportedExtensions.has(extensionId) && editor.editorState.mode !== "inlineControlsOnly"
        );
    },
    expandedElement(editor) {
        return (
            <EditorControlButton
                friendlyName={friendlyName}
                data-testid="boldControl"
                icon={icon}
                isToggled={editor.tiptapEditor.isActive(extensionId)}
                onClick={() => onClick(editor)}
                disabled={!this.isControlEnabled(editor)}
            />
        );
    },
    isControlEnabled({ tiptapEditor }) {
        return (
            tiptapEditor.can().chain().focus().toggleBold().run() &&
            !isSelectionExclusivelyInTitle(tiptapEditor, tiptapEditor.state.selection)
        );
    },
    collapsedActiveKeys({ tiptapEditor }) {
        return tiptapEditor.isActive(extensionId) ? [extensionId] : [];
    },
    collapsedMenuItem(editor) {
        return (
            <InputRecaptureHackMenuItem
                editor={editor}
                menuComponent={BTMenu.Item}
                key={this.key}
                menuProps={{
                    testid: this.key,
                    className: "btEditorControlBarMenuItem",
                    onClick: () => onClick(editor),
                    icon,
                    disabled: !this.isControlEnabled(editor),
                }}
            >
                {friendlyName}
            </InputRecaptureHackMenuItem>
        );
    },
};
export default boldControl;
